export default __webpack_public_path__ + "static/media/social-icon1.56ff0cea.svg";